<template lang="html">
  <div class="mb4 pv3 ph4 pl-box-shadow">
    <div class="row col-xs center-xs middle-xs title">
      <span>Written RoundTable Engagement</span>
      <i
        v-my-tooltip="onlineRoundtableEngagementTooltip"
        class="fa fa-info-circle"
        style="color: #848484"
        aria-hidden="true"
      />
    </div>
    <canvas id="online-roundtable-engagement-data"></canvas>
  </div>
</template>
<script>
  import Chart from 'chart.js';
  export default {
    data() {
      return {
        onlineRoundtableEngagementTooltip:
          'This chart shows the cumulative number of new ideas (submissions), comments, and applause given by students to their peers across all Written RoundTables in each of the months between the selected dates.',
        myLineChart: [],
      };
    },
    watch: {
      onlineRTEngagement() {
        this.myLineChart.destroy();
        this.createEngagementGraph();
      },
    },
    props: {
      onlineRTEngagement: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {
      createEngagementGraph() {
        const payload = {
          type: 'bar',
          data: [],
        };
        const array = [];

        if (this.onlineRTEngagement && this.onlineRTEngagement.length) {
          const month = this.onlineRTEngagement.map((label) => {
            const [year, month] = label.month.split('T')[0].split('-');

            return `${month}/${year}`;
          });
          payload.data.labels = month;
          const applauses_count = this.onlineRTEngagement.map(
            (data) => data.online_roundtables_engagement.applauses_count
          );
          const comments_count = this.onlineRTEngagement.map(
            (data) => data.online_roundtables_engagement.comments_count
          );
          const submissions_count = this.onlineRTEngagement.map(
            (data) => data.online_roundtables_engagement.submissions_count
          );

          array.push(
            {
              type: 'line',
              label: 'Applause',
              fill: false,
              borderColor: '#FFCC33',
              backgroundColor: '#FFCC33',
              tension: 0,
              data: applauses_count,
            },
            {
              label: 'Submissions',
              borderColor: '#85D7E2',
              backgroundColor: '#85D7E2',
              data: submissions_count,
            },
            {
              label: 'Comments',
              borderColor: '#70BD66',
              backgroundColor: '#70BD66',
              data: comments_count,
            }
          );
          (payload.data.datasets = array),
            (payload.options = {
              responsive: true,
              legend: {
                onHover: function (e) {
                  e.target.style.cursor = 'pointer';
                },
                display: true,
                labels: {
                  usePointStyle: true,
                  boxWidth: 7,
                },
              },

              scales: {
                xAxes: [
                  {
                    stacked: true,
                  },
                ],
                yAxes: [
                  {
                    stacked: true,
                  },
                ],
              },
              tooltips: {
                xPadding: 25,
                yPadding: 15,
                titleAlign: 'center',
                footerAlign: 'center',
                bodyAlign: 'center',
                backgroundColor: '#fff',
                titleFontColor: '#595959',
                bodyFontColor: '#595959',
                footerFontColor: '#595959',
                borderWidth: 0.2,
                borderColor: '#595959',
                callbacks: {
                  label: function (tooltipItem, data) {
                    return (
                      data.datasets[tooltipItem.datasetIndex].data[
                        tooltipItem.index
                      ] + ''
                    );
                  },
                  footer: function (tooltipItem, data) {
                    return [data.datasets[tooltipItem[0].datasetIndex].label];
                  },
                },
                bodyFontSize: 30,
                displayColors: false,
              },
              hover: {
                onHover: function (e) {
                  var point = this.getElementAtEvent(e);
                  if (point.length) e.target.style.cursor = 'pointer';
                  else e.target.style.cursor = 'default';
                },
              },
            });
        }
        const ctx = document.getElementById(
          'online-roundtable-engagement-data'
        );
        this.myLineChart = new Chart(ctx, payload);
      },
    },
    mounted() {
      this.createEngagementGraph();
    },
  };
</script>
<style scoped lang="stylus">
  .title
    margin: 0 0 20px 0
    span
      margin-right: 10px
      font-size: 18px
      font-weight: 600
</style>



// WEBPACK FOOTER //
// onlineRoundtableEngagement.vue?8df16c0e